import { axiosInstance } from '.'
import {
  GET_KYC_V1,
  GET_KYC_REPORT_LINK_V1,
  GET_DOCUMENT_WITH_KYC_V1,
  GET_INVESTOR_BANK_DETAILS_V1,
  UPDATE_KYC_ONS_NOTIFICATION_EMAIL,
  GET_INVESTOR_PORTFOLIO_IDS,
} from './endpoints'

export const kycServices = {
  getKYC_v1: async (investorId: string) => {
    try {
      const data: any = await axiosInstance.get(GET_KYC_V1(investorId))
      return data
    } catch (error: any) {
      return error
    }
  },
  generateKYCReportLink: async (investorKycId: string) => {
    try {
      return await axiosInstance.get(GET_KYC_REPORT_LINK_V1, {
        params: { investorKycId },
      })
    } catch (error: any) {
      return error.response
    }
  },
  getDocumentWithKYC: async (investorId: string) => {
    try {
      const data: any = await axiosInstance.get(GET_DOCUMENT_WITH_KYC_V1(investorId))
      return data
    } catch (error: any) {
      return error
    }
  },
  getInvestorBankDetails: async (investorId: string) => {
    try {
      const data: any = await axiosInstance.get(GET_INVESTOR_BANK_DETAILS_V1(investorId))
      return data
    } catch (error: any) {
      return error
    }
  },
  updateONSNotificationEmails: async (sendONSNotificationEmails: boolean, investorId: string) => {
    try {
      const data: any = await axiosInstance.patch(UPDATE_KYC_ONS_NOTIFICATION_EMAIL(investorId), {
        sendONSNotificationEmails,
      })
      return data
    } catch (error: any) {
      return error.response
    }
  },
  getInvestorPortfolioIds: async (investorId: string) => {
    try {
      const data: any = await axiosInstance.get(GET_INVESTOR_PORTFOLIO_IDS(investorId))
      return data
    } catch (error: any) {
      return error.response
    }
  },
}
